var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.ControlButtons
  }, _vm._l(_vm.controls, function (control) {
    return _c('CIconButton', {
      key: control.value,
      attrs: {
        "text": control.title,
        "icon": "i-".concat(control.icon),
        "disabled": control.disabled
      },
      on: {
        "click": function click($event) {
          return _vm.$emit(control.value);
        }
      }
    });
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };